<template>
  <div class="control has-icons-left" :data-e2e="dataE2e">
    <span class="icon" :class="disabled ? 'has-text-grey' : 'has-text-primary'">
      <i class="cls cls-search"></i>
    </span>
    <input
      :placeholder="$t('core.search')"
      v-model="computedValue"
      class="input search-field"
      type="search"
      :disabled="disabled"
      @focus="setIsFocused(true)"
      @blur="setIsFocused(false)"
    />
  </div>
</template>

<script>
import { FormComputedValueMixin } from '/@/modules/core/form/mixins/FormComputedValueMixin';
import { SearchInputEvent } from '@/modules/core/table/constants/SearchInputEvent';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SearchInput',
  emits: ['is-focused'],
  mixins: [FormComputedValueMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '225px'
    },
    dataE2e: {
      type: String,
      required: false
    }
  },
  events() {
    return {
      [SearchInputEvent.FOCUS]: this.focus
    };
  },
  computed: {
    widthStyle() {
      return this.width;
    }
  },
  methods: {
    focus() {
      this.$el.querySelector('input').focus();
    },
    setIsFocused(value) {
      this.$emit('is-focused', value);
    }
  }
};
</script>

<style scoped>
div.control {
  input.search-field {
    border-color: var(--ce-grey-light);
    width: v-bind(widthStyle);
    margin-bottom: 0;

    &:focus {
      box-shadow: none;
      border-bottom-width: 1px;
      border-color: var(--ce-grey-lighter);
      color: var(--ce-grey-dark);
    }
  }

  span.icon {
    top: var(--ce--4px);
    left: var(--ce--2px);
    font-size: var(--ce-18px);
  }
}
@media (max-width: CE_MOBILE) {
  div.control {
    input.search-field {
      border-radius: var(--ce-radius-large) !important;
      width: unset !important;
      margin-bottom: 0 !important;
    }
    span.icon {
      top: 0px;
    }
  }
}
</style>
